jQuery(document).ready(function($) {
  $('.custom-furniture-slider').slick({
    dots: false,
    slidesToShow: 3,
    prevArrow: '<div class="flex-container align-middle align-center circle reviews-nav"><i class="fal fa-angle-left"></i></div>',
    nextArrow: '<div class="flex-container align-middle align-center circle reviews-nav"><i class="fal fa-angle-right"></i></div>',
    responsive: [{
      breakpoint: 959,
      settings: {
        slidesToShow: 2
      }
    } ,{
      breakpoint: 767,
      settings: {
        centerPadding: '20vw',
        dots: true,
        autoplay: false,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        arrows: false,
      }
    },{
      breakpoint: 1,
      settings: {
        centerPadding: '10.667vw',
        dots: true,
        autoplay: false,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        arrows: false,
      }
    }]
  })
})
